import { useState } from "react"

import CvaAffectiveForm from "@/components/cva-affective-form"
import CvaDescriptiveForm from "@/components/cva-descriptive-form"

interface Sample {
  id: number
  name: string
}

interface Cupping {
  id: number
  title: string
  cupping_form: string
  cupping_form_label: string
  samples: Sample[]
}

interface Props {
  cupping: Cupping
  existing_cupping?: any
}

export default function CvaCombinedForm({ cupping, existing_cupping }: Props) {
  const [activeTab, setActiveTab] = useState<"descriptive" | "affective">(
    "descriptive",
  )

  return (
    <div className="space-y-4">
      {/* Tab Switcher */}
      <div className="flex gap-1 rounded-lg border p-1">
        <button
          type="button"
          onClick={() => setActiveTab("descriptive")}
          className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            activeTab === "descriptive"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-accent hover:text-foreground"
          }`}
        >
          Descriptivo
        </button>
        <button
          type="button"
          onClick={() => setActiveTab("affective")}
          className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            activeTab === "affective"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-accent hover:text-foreground"
          }`}
        >
          Afectivo
        </button>
      </div>

      {/* Tab Content */}
      <div className={activeTab === "descriptive" ? "" : "hidden"}>
        <CvaDescriptiveForm
          cupping={cupping}
          existing_cupping={existing_cupping}
        />
      </div>
      <div className={activeTab === "affective" ? "" : "hidden"}>
        <CvaAffectiveForm
          cupping={cupping}
          existing_cupping={existing_cupping}
        />
      </div>
    </div>
  )
}
